import { Menu, Search } from 'components/header'
import { HeaderMenuNames } from 'constants/enums'
export class HeaderStore {
    public menus: { [key in HeaderMenuNames]: Menu | undefined } = {
        [HeaderMenuNames.PRIMARY]: undefined,
        [HeaderMenuNames.ACCOUNT]: undefined
    }
    public search: Search

    private static _instance: HeaderStore
    public static getInstance(): HeaderStore {
        return this._instance || (this._instance = new this())
    }

    public closeAllMenus(): void {
        for (const menu of Object.values(this.menus)) {
            if (menu) menu.closeMenu()
        }
    }
}
